"use client";
import { Workflow } from "lucide-react";

import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

import { useAutomationsModel } from "./automationsPageModel";
import AutomationList from "./_cmp/AutomationList";
import AutomationListSkeleton from "./_cmp/AutomationListSkeleton";
import AutomationsToolbar from "./_cmp/AutomationsToolbar";

export default function AutomationsPage() {
  const isMobile = useIsMobile();
  const {
    automations,
    isLoading,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    eventFilter,
    setEventFilter,
    usedEventKeys,
    handleDelete,
  } = useAutomationsModel();

  const toolbar = (
    <AutomationsToolbar
      search={search}
      onSearchChange={setSearch}
      statusFilter={statusFilter}
      onStatusFilterChange={setStatusFilter}
      eventFilter={eventFilter}
      onEventFilterChange={setEventFilter}
      usedEventKeys={usedEventKeys}
    />
  );

  const list = isLoading ? (
    <AutomationListSkeleton />
  ) : (
    <AutomationList automations={automations} onDelete={handleDelete} />
  );

  const subtitle = `${automations.length} ${automations.length === 1 ? "automation" : "automations"}`;

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Automations"
              icon={Workflow}
              subtitle={subtitle}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            {toolbar}
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader title="Automations" icon={Workflow} subtitle={subtitle} />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          {toolbar}

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>
    </PageContainer>
  );
}
